module.exports = __webpack_public_path__ + "img/delitos.9aa62703.png";